import { IonIcon } from '@ionic/react';
import { caretDown, caretUp, playOutline, reloadOutline, stopOutline, trashBinOutline } from 'ionicons/icons';
import { useWebSocket } from "providers/WebSocketProvider";
import { useEffect, useState } from "react";
import Api from "utils/api";

const SourceActions = ({ state, status, server, sourceId }) => {

    const Actions = {
        ENABLE: 'enable',
        DISABLE: 'disable',
        RESTART: 'restart',
        START: 'start',
        STOP: 'stop'
    };

    const sockets = useWebSocket();
    const [socket, setSocket] = useState(null);


    useEffect(() => {
        if (sockets.length > 0) {
            const socketObj = sockets.find(item => item.id === server);
            if (socketObj) {
                setSocket(socketObj.socket)
            }
        }
    }, [sockets]);


    const handleAction = async (action) => {

        switch (action) {
            case Actions.ENABLE:
                await Api.post('/streams/' + sourceId + '/status/1');
                break;
            case Actions.DISABLE:
                await Api.post('/streams/' + sourceId + '/status/0');
                break;
            default:
        }

        const payload = {
            action: action,
            id: sourceId
        };

        socket.send(JSON.stringify(payload))
    }



    if (sockets.length === 0) {
        return <></>
    }

    if (!status) {
        return (
            <>
                <IonIcon icon={caretUp} style={{ cursor: 'pointer' }} onClick={() => handleAction(Actions.ENABLE)} title="Activar" />
                {' '}
                <IonIcon icon={trashBinOutline} style={{ cursor: 'pointer' }} title="Eliminar" />
            </>
        )
    }

    const menu = <>
        {/*}
        <PencilOutline color={'#fff'} />
        {' '}
        <TrashBinOutline color={'#fff'} />
        {' '}
        <CloseCircleOutline color={'#fff'} />
        {' '}
        <CodeSlashOutline color={'#fff'} />
        {' '}
        */}
        <IonIcon icon={reloadOutline} style={{ cursor: 'pointer' }} onClick={() => handleAction(Actions.RESTART)} title="Reiniciar" />{' '}
        {' '}
        <IonIcon icon={caretDown} style={{ cursor: 'pointer' }} onClick={() => handleAction(Actions.DISABLE)} title="Desactivar" />
        {' '}
        <IonIcon icon={trashBinOutline} style={{ cursor: 'pointer' }} title="Eliminar" />
        {/*}
        <IonIcon icon={codeSlashOutline} onClick={() => {}} style={{ cursor: 'pointer' }} title="Ver comando" />
        {
            */
        }
    </>


    switch (state) {
        case 0:
            return <><IonIcon icon={playOutline} style={{ cursor: 'pointer' }} onClick={() => handleAction(Actions.START)} title="Iniciar" />{' '}{menu}</>
        case 1:
        case 2:
            return <><IonIcon icon={stopOutline} style={{ cursor: 'pointer' }} onClick={() => handleAction(Actions.STOP)} title="Detener" />{' '}{menu}</>
        default:
            return <>{menu}</>
    }
}

export default SourceActions;